import { useLanguage } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="border-t border-[#E2E8F0] bg-white mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 bg-[#002FA7] rounded-sm flex items-center justify-center text-white font-bold text-sm font-display">
              CS
            </div>
            <span className="font-display font-bold tracking-tight text-[15px]">
              Civic Sense Abroad
            </span>
          </div>
          <p className="text-sm text-[#475569] max-w-xs leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>
        <div>
          <div className="overline mb-3">Learn</div>
          <ul className="space-y-2 text-sm text-[#475569]">
            <li>Country Guides</li>
            <li>Civic Principles</li>
            <li>Trip Checklist</li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Disclaimer</div>
          <p className="text-sm text-[#475569] leading-relaxed">{t.footer.built}</p>
        </div>
      </div>
      <div className="border-t border-[#E2E8F0] py-4 text-center text-xs text-[#475569]">
        © {new Date().getFullYear()} Civic Sense Abroad
      </div>
    </footer>
  );
}
